import { Navigate } from 'react-router';
import { FullPageSpinner } from '../../components/FullPageSpinner';
import { LoginPage } from './LoginPage';
import { useSession } from './useSession';

/** `/login` itself: the inverse of AuthGuard — an already-authenticated
 * visitor is sent straight to the dashboard instead of seeing the form. */
export function LoginRoute() {
  const { data: user, isLoading } = useSession();

  if (isLoading) {
    return <FullPageSpinner />;
  }

  if (user) {
    return <Navigate to="/" replace />;
  }

  return <LoginPage />;
}
